import React, { useContext, useEffect } from "react";

import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import Cookies from "js-cookie";
import { useUser } from "../User.hook";
import { getBaseDomain as loginBasePath } from "@Utils/Functions";
import { getNpsSiteId, resetNpsSession } from "shared-components/Components/NpsSurveyCard/npsSurvey.service";

export const Logout = ({ className = '' }) => {
	const { logout } = useUser();
	const { country_code, site_name } = useContext(ConfigStateContext);

	useEffect(() => {
		if (logout.response.data && !logout.response.loading) {
			Cookies.remove("user_info", { domain: loginBasePath(), path: "/" });
			Cookies.remove("frontend_token", { domain: loginBasePath(), path: "/" });
			localStorage.removeItem("user_md5");
			localStorage.removeItem("one_tap_logged");
			localStorage.removeItem('user')
			localStorage.removeItem('contactForm')
			localStorage.removeItem('selectedCountryCode')

			const npsSiteId = getNpsSiteId(site_name, country_code);
			if (npsSiteId) resetNpsSession(npsSiteId);

			window.location.reload();

			// if (country_code === "CO") {
			// 	window.location.assign('/?logout=true')
			// }
			// else window.location.assign("/sitio/index.php?mid=login&func=logout");
		}
	}, [logout.response]);

	return (
		<div className={className}
			onClick={() => {
				if (!logout.response.called) logout.send();
			}}>
			{"Cerrar Sesión"}
		</div>
	);
};
